import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    step: null,
    portraitUUID: null,
    STEPS: {
        INITIAL_USER_CREATED: 'initial_user_created',
        INITIAL_IMAGE_CREATED: 'initial_image_created',
        IMAGE_HANDLED: 'image_handled',
        PAYMENT_SUCCESS_NO_ISSUE: 'payment_success_no_issue',
        PAYMENT_SUCCESS_ISSUE: 'payment_success_issue',
        PAYMENT_FAILED: 'payment_failed',
    },
    generalError: null,
    generalErrorMessage: null,
    isLoadingMain: false,
    mainButtonName: 'Participate Now',
    imageErrorCode: null,
    imageErrorMessage: null,
};

const sharedStateSlice = createSlice({
    name: 'sharedState',
    initialState,
    reducers: {
        setStep(state, action) {
            state.step = action.payload;
        },
        setPortraitUUID(state, action) {
            state.portraitUUID = action.payload;
        },
        setErrorCode(state, action) {
            state.generalError = action.payload;
        },
        setErrorMessage(state, action) {
            state.generalErrorMessage = action.payload;
        },
        setIsLoadingMain(state, action) {
            state.isLoadingMain = action.payload;
        },
        setMainButtonName(state, action) {
            state.mainButtonName = action.payload;
        },
        setImageErrorCode(state, action) {
            state.imageErrorCode = action.payload;
        },
        setImageErrorMessage(state, action) {
            state.imageErrorMessage = action.payload;
        }
    },
});

export const getMainButtonName = (state) => {
    if (state.sharedState.step == null) return 'buttons.participate';
    if (
        state.sharedState.step === state.sharedState.STEPS.INITIAL_USER_CREATED ||
        state.sharedState.step === state.sharedState.STEPS.INITIAL_IMAGE_CREATED ||
        state.sharedState.step === state.sharedState.STEPS.PAYMENT_SUCCESS_ISSUE
    ) return 'buttons.continue';
    return 'buttons.participate';
};

export const { setStep, setPortraitUUID, setErrorCode, setErrorMessage, setIsLoadingMain, setMainButtonName, setImageErrorCode, setImageErrorMessage } = sharedStateSlice.actions;
export default sharedStateSlice.reducer;
